export default __webpack_public_path__ + "static/media/solution.02b13fd4.jpg";